function initMaps() {

  const typeIcons = {
    restaurant: '/wp-content/themes/LumiCapital/assets/images/icons/marker-restaurant.png',
    supermarket: '/wp-content/themes/LumiCapital/assets/images/icons/marker-shop.png',
    school: '/wp-content/themes/LumiCapital/assets/images/icons/marker-school.png',
    gym: '/wp-content/themes/LumiCapital/assets/images/icons/marker-sport.png',
    entertainment: '/wp-content/themes/LumiCapital/assets/images/icons/marker-entertainment.png',
    public_transport: '/wp-content/themes/LumiCapital/assets/images/icons/marker-transport.png',
  };

  function initApartmentMap() {
    const locations = window.maps_locations || [];
    const mapEl = document.getElementById('apartment-map');
    if (!mapEl || !locations.length) return;

    // Compute the geographic center
    let totalLat = 0;
    let totalLng = 0;
    let validLocations = 0;

    locations.forEach((loc) => {
      const [lat, lng] = loc.location.split(',').map(Number);
      if (!isNaN(lat) && !isNaN(lng)) {
        totalLat += lat;
        totalLng += lng;
        validLocations++;
      }
    });

    if (!validLocations) return;

    const centerLat = totalLat / validLocations;
    const centerLng = totalLng / validLocations;

    const map = new google.maps.Map(mapEl, {
      zoom: 12,
      center: {
        lat: centerLat,
        lng: centerLng,
      },
    });

    locations.forEach((loc) => {
      const [lat, lng] = loc.location.split(',').map(Number);
      if (isNaN(lat) || isNaN(lng)) return;

      const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
        title: loc.title,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `<div class="map-info-window" style="
              padding: 14px 0 0 8px;
            ">
              <span class="lumi-icon"></span><span style="margin-top: 0; font-size: 16px;">${loc.title}</span>
            </div>`,
      });

      infoWindow.open(map, marker);

      marker.addListener('click', () => infoWindow.open(map, marker));
    });
  }

  initApartmentMap();

  function initAreaMap() {
    const locations = window.maps_locations || [];
    const buildingLocations = window.building_locations || [];
    const mapEl = document.getElementById('area-map');

    if (!mapEl || !locations.length) return;

    const map = new google.maps.Map(mapEl, {
      zoom: 14,
      center: window.maps_center || { lat: 59.437, lng: 24.7536 },
      styles: [
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });

    const markers = [];

    if (mapEl.dataset.mainLocation && mapEl.dataset.mainLocationName) {
      const [lat, lng] = mapEl.dataset.mainLocation.split(',').map(Number);
      if (!isNaN(lat) && !isNaN(lng)) {
        const mainMarker = new google.maps.Marker({
          position: { lat, lng },
          map,
          title: mapEl.dataset.mainLocationName,
          icon: undefined, // Optional: set a custom icon for main location
        });

        const mainInfoWindow = new google.maps.InfoWindow({
          content: `<div class="map-info-window" style="
              padding: 14px 0 0 8px;
            ">
              <span class="lumi-icon"></span><span style="margin-top: 0; font-size: 16px;">${mapEl.dataset.mainLocationName}</span>
            </div>`,
        });

        mainInfoWindow.open(map, mainMarker);

        mainMarker.addListener('click', () => mainInfoWindow.open(map, mainMarker));

        // Add to markers array but mark as always visible
        markers.push({ marker: mainMarker, type: null, alwaysVisible: true });
      }
    }

    if (buildingLocations.length) {
      buildingLocations.forEach((loc) => {
        const [lat, lng] = loc.location.split(',').map(Number);
        if (isNaN(lat) || isNaN(lng)) return;

        const marker = new google.maps.Marker({
          position: { lat, lng },
          map,
          title: loc.title,
          icon: undefined, // Optional: set a custom icon for building location
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `<div class="map-info-window" style="
              padding: 14px 0 0 8px;
            ">
              <span class="lumi-icon"></span><span style="margin-top: 0; font-size: 16px;">${loc.title}</span>
            </div>`,
        });

        infoWindow.open(map, marker);

        marker.addListener('click', () => infoWindow.open(map, marker));

        // Add to markers array but mark as always visible
        markers.push({ marker, type: null, alwaysVisible: true });
      });
    }


    // Create markers
    locations.forEach((loc) => {
      const [lat, lng] = loc.location.split(',').map(Number);
      if (isNaN(lat) || isNaN(lng)) return;

      const iconUrl = typeIcons[loc.type];

      const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
        title: loc.title,
        icon: iconUrl
          ? {
            url: iconUrl,
            scaledSize: new google.maps.Size(24, 24),
          }
          : undefined,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: loc.link
          ? `
              <div class="map-info-window" style="
                padding: 14px 0 0 16px;
              ">
                <a href="${loc.link}" target="_blank" style="margin-top: 0; font-size: 16px;">${loc.title}</a>
              </div>`
          : `<div class="map-info-window" style="
                padding: 14px 0 0 16px;
              ">
              <span style="margin-top: 0; font-size: 16px;">${loc.title}</span>
            </div>`,
      });

      marker.addListener('click', () => infoWindow.open(map, marker));

      markers.push({ marker, type: loc.type, alwaysVisible: false });
    });

    // Filter controls
    const buttons = document.querySelectorAll('.filter-controls .th-button');
    let selectedTypes = new Set();

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.dataset.type;

        if (selectedTypes.has(type)) {
          selectedTypes.delete(type);
          btn.classList.remove('active');
          btn.classList.add('alt-extra');
        } else {
          selectedTypes.add(type);
          btn.classList.add('active');
          btn.classList.remove('alt-extra');
        }

        updateMarkers();
      });
    });

    function updateMarkers() {
      markers.forEach(({ marker, type, alwaysVisible }) => {
        const shouldShow = alwaysVisible || selectedTypes.has(type);
        marker.setMap(shouldShow ? map : null);
      });
    }

    // ✅ Trigger first filter by default
    if (buttons.length) {
      buttons[0].click();
    }
  }

  initAreaMap();
}

window.initMaps = initMaps;
